import { useSelector } from 'react-redux';
import useTranslations from '~/components/translation/use-translations';
import { selectShowClosedPopup, setShowClosedPopup } from './ducks/index';
import Binary from '~/components/modal/binary';
import { useAppDispatch } from '~/store/types';

const NS = 'ACCOUNT_CLOSED_POPUP';
const TEXT_KEYS = ['HEADER', 'DESCRIPTION', 'CTA_BUTTON'].map(v => `${NS}_${v}`);

const ClosurePopup: React.FC = () => {
	const dispatch = useAppDispatch();
	const showClosedPopup = useSelector(selectShowClosedPopup);
	const { translations: tr, isLoadingTranslations } = useTranslations(TEXT_KEYS);

	if (!showClosedPopup) {
		return null;
	}

	return !isLoadingTranslations ? (
		<Binary
			title={tr.ACCOUNT_CLOSED_POPUP_HEADER}
			message={tr.ACCOUNT_CLOSED_POPUP_DESCRIPTION}
			confirmButtonText={tr.ACCOUNT_CLOSED_POPUP_CTA_BUTTON}
			onConfirm={() => dispatch(setShowClosedPopup(false))}
		/>
	) : null;
};

export default ClosurePopup;
